import React, {useState} from 'react'

const TodoInput = ({onAddTodo}) => {

    const [inputValue, setInputValue] = useState("");
    const isInputEmpty = inputValue.trim() === "";


    const handleSubmit = () => {
      if (isInputEmpty) return;

      //把值存到onAddTodo 在帶回parent
      onAddTodo(inputValue);
      //清空input 欄位
      setInputValue("");
    };

    //如果user點下enter也可以提交todo
    const handleKeyDown = (event) => {
      if (event.key === "Enter") {
        handleSubmit();
      }
    };



  return (
    <div className="todo-input">
      <input
        type="text"
        placeholder="Write something..."
        value={inputValue}
        onChange={(event) => setInputValue(event.target.value)}
        onKeyDown={handleKeyDown}
      />

      <button
        type="button"
        className="add-button"
        onClick={handleSubmit}
        disabled={isInputEmpty}
      >
        +
      </button>
    </div>
  )
}

export default TodoInput
